import { portalUploadSteps, type PortalUploadGuideProps } from '../lib/portalUploadSteps'
import { Icon } from './ui'

/**
 * Guida "Come si carica sul portale" (passi in lib/portalUploadSteps.ts): chiusa mostra solo il prossimo passo,
 * aperta l'elenco completo.
 */
export function PortalUploadGuide(p: PortalUploadGuideProps) {
  const { portal, steps, after } = portalUploadSteps(p)
  const next = steps.findIndex(s => !s.done)
  const nextStep = next >= 0 ? steps[next] : undefined
  return (
    <details className="ecrm-guide">
      <summary>
        <Icon name="route" size={20} />
        <span>
          {nextStep
            ? <>Prossimo passo per {portal} ({next + 1} di {steps.length}): <strong>{nextStep.text}</strong></>
            : <>Tutti i passi per {portal} sono fatti.</>}
        </span>
        <span className="ecrm-guide__more">Tutti i passi</span>
      </summary>
      <div className="ecrm-guide__body">
        <ol>
          {steps.map((s, i) => (
            <li key={i} style={{ fontWeight: i === next ? 600 : undefined, opacity: s.done ? 0.7 : undefined }}>
              {s.done ? '✓ ' : ''}{s.text}
            </li>
          ))}
        </ol>
        <small>{after}</small>
      </div>
    </details>
  )
}
